<template>
    <table class="table table-striped table-hover table-sm">
        <tbody>
        <template v-for="itemDataAccessor in itemInformation">
            <tr v-if="isCheckedAndNotEmpty(itemDataAccessor)">
                <td :class="paddingClasses" :style="paddingInlineStyles">
                    {{ getTranslation(itemDataAccessor) }}
                </td>

                <td :class="paddingClasses" :style="paddingInlineStyles">
                    {{ getFieldValue(itemDataAccessor) }}
                </td>
            </tr>
        </template>
        </tbody>
    </table>
</template>

<script>
import get from "lodash/get";
import find from "lodash/find";
import isObject from "lodash/isObject";
import { isNullOrUndefined, isDefined } from "../../../ceres/helper/utils";

export default {
    name: "item-data-table",

    props: {
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        itemInformation:
        {
            type: Array,
            default: () => []
        },
        dimensionProperties:
        {
            type: Array,
            default: () => []
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        }
    },

    data()
    {
        return {
            translationMap: {
                "item.id"                         : "singleItemId",
                "item.condition.names.name"       : "singleItemCondition",
                "item.ageRestriction"             : "singleItemAge",
                "variation.externalId"            : "singleItemExternalVariationId",
                "variation.model"                 : "singleItemModel",
                "item.manufacturer.externalName"  : "singleItemManufacturer",
                "item.producingCountry.names.name": "singleItemManufacturingCountry",
                "unit.names.name"                 : "singleItemContent",
                "variation.weightG"               : "singleItemWeight",
                "variation.weightNetG"            : "singleItemNetWeight",
                "item.variationDimensions"        : "singleItemDimensions",
                "variation.customsTariffNumber"   : "singleItemCustomsTariffNumber"
            },
            formatMap: {
                "item.ageRestriction": {
                    type: "filter",
                    value: "ageRestriction"
                },
                "variation.weightG": {
                    type: "text",
                    value: " g"
                },
                "variation.weightNetG": {
                    type: "text",
                    value: " g"
                }
            }
        };
    },

    methods:
    {
        isCheckedAndNotEmpty(path)
        {
            if (path === "item.ageRestriction")
            {
                // remove check for the age restriction to be greater than zero (0 means 'No age restriction')
                return true;
            }
            if (path !== "item.variationDimensions")
            {
                const value = get(this.currentVariation, path);

                return value !== "" && value !== 0;
            }
            else
            {
                return ["variation.lengthMM", "variation.widthMM", "variation.heightMM"]
                    .some(element =>
                    {
                        const value = this.getFieldValue(element);

                        return !isNullOrUndefined(value) && value !== 0;
                    });
            }
        },

        getTranslation(path)
        {
            return this.$translate(
                "Ceres::Template." + this.translationMap[path]
            );
        },

        getFieldValue(path)
        {
            let value;

            if (path === "item.variationDimensions")
            {
				if (this.dimensionProperties.length && typeof this.currentVariation.properties !== "undefined") {
					const lengthProperty = find(this.currentVariation.properties, { "propertyId": this.dimensionProperties[0].length });
					const widthProperty = find(this.currentVariation.properties, { "propertyId": this.dimensionProperties[0].width });
					const heightProperty = find(this.currentVariation.properties, { "propertyId": this.dimensionProperties[0].height });

					if (isObject(lengthProperty) && isObject(widthProperty) && isObject(heightProperty)) {
						value = lengthProperty.valueFloat + "×"
							+ widthProperty.valueFloat + "×"
							+ heightProperty.valueFloat + "mm";
					}
				} else {
					value = get(this.currentVariation, "variation.lengthMM") + "×"
						+ get(this.currentVariation, "variation.widthMM") + "×"
						+ get(this.currentVariation, "variation.heightMM") + "mm";
				}
            }
            else if (path === "unit.names.name")
            {
                value = get(this.currentVariation, "unit.content") + " " + get(this.currentVariation, "unit.names.name");
            }
            else
            {
                value = get(this.currentVariation, path);
            }

            return this.formatFieldData(value, path);
        },

        formatFieldData(value, path)
        {
            const format = this.formatMap[path];

            if (isDefined(format))
            {
                switch (format.type)
                {
                    case "text":
                        return value + format.value;
                    case "filter":
                        const filterMethod = get(this.$options.filters, format.value);

                        return isDefined(filterMethod) ? filterMethod(value) : value;
                }
            }

            return value;
        }
    }
}
</script>
